import DOMPurify from "dompurify";

// Article HTML is authored by users and renders on the dashboard origin, where auth cookies apply.
export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
  });
}
